<template>
  <div class="d-flex justify-end column-gap-4">
    <AppSortSelect
      :disabled="disabled"
      :selected-options="selectedOptions"
      :value="sort"
      v-bind="$attrs"
      data-locator="sort-bibles-select"
    />
    <template v-if="currentRoom.userRights.canCreateBibles">
      <app-button
        :disabled="biblesPending"
        data-locator="add-bible-button"
        @click="$emit('generate-bible')"
      >
        {{ $t('project.bibles.BiblesButtonBar.addBible') }}
      </app-button>
    </template>
  </div>
</template>

<script>
import { mapState } from 'vuex'

import AppSortSelect from '@/common/app-sort-select/AppSortSelect.vue'
import { SORT_OPTIONS } from '@/common/app-sort-select/sortOptions'

export default {
  name: 'BiblesButtonBar',
  components: { AppSortSelect },
  emits: ['generate-bible'],
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    sort: {
      type: String,
      required: true,
    },
  },
  data () {
    return {
      selectedOptions: {
        [SORT_OPTIONS.NAME]: SORT_OPTIONS.NAME,
        [SORT_OPTIONS.CREATION_DATE]: SORT_OPTIONS.CREATION_DATE,
      },
      openBibleGenerateDialog: false,
    }
  },
  computed: {
    ...mapState('bibles', ['biblesPending']),
    ...mapState('room', ['currentRoom']),
  },
}
</script>
